// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Js_math = require("rescript/lib/js/js_math.js");
var Belt_Map = require("rescript/lib/js/belt_Map.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var MM_provers = require("../mm-utils/MM_provers.bs.js");
var MM_wrk_ctx = require("./MM_wrk_ctx.bs.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_HashMap = require("rescript/lib/js/belt_HashMap.js");
var MM_proof_tree = require("../mm-utils/MM_proof_tree.bs.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Belt_SetString = require("rescript/lib/js/belt_SetString.js");
var MM_proof_table = require("../mm-utils/MM_proof_table.bs.js");
var MM_syntax_tree = require("../mm-utils/MM_syntax_tree.bs.js");
var Belt_MutableMap = require("rescript/lib/js/belt_MutableMap.js");
var MM_parenCounter = require("../mm-utils/MM_parenCounter.bs.js");
var MM_substitution = require("../mm-utils/MM_substitution.bs.js");
var MM_proof_tree_dto = require("../mm-utils/MM_proof_tree_dto.bs.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Belt_MutableMapInt = require("rescript/lib/js/belt_MutableMapInt.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");
var Expln_utils_common = require("@expln/utils/src/main/Expln_utils_common.bs.js");
var Belt_MutableMapString = require("rescript/lib/js/belt_MutableMapString.js");
var Belt_MutableSetString = require("rescript/lib/js/belt_MutableSetString.js");

function contIsEmpty(cont) {
  if (cont.TAG === /* Text */0) {
    return cont._0.length === 0;
  } else {
    return MM_syntax_tree.syntaxTreeIsEmpty(cont._0);
  }
}

function contToArrStr(cont) {
  if (cont.TAG === /* Text */0) {
    return cont._0.map(function (stmtSym) {
                return stmtSym.sym;
              });
  } else {
    return MM_syntax_tree.syntaxTreeToSymbols(cont._0);
  }
}

function contToStr(cont) {
  return contToArrStr(cont).join(" ");
}

function strToCont(str, preCtxColors, wrkCtxColors, param) {
  return {
          TAG: /* Text */0,
          _0: MM_parser.getSpaceSeparatedValuesAsArray(str).map(function (sym, i) {
                var color = Belt_Option.flatMap(preCtxColors, (function (map) {
                        return Belt_HashMapString.get(map, sym);
                      }));
                var tmp;
                if (color !== undefined) {
                  tmp = color;
                } else {
                  var color$1 = Belt_Option.flatMap(wrkCtxColors, (function (map) {
                          return Belt_HashMapString.get(map, sym);
                        }));
                  tmp = color$1 !== undefined ? color$1 : undefined;
                }
                return {
                        id: String(i) + sym,
                        sym: sym,
                        color: tmp
                      };
              })
        };
}

function jstfToStr(jstf) {
  return (jstf.args.join(" ") + " : " + jstf.asrt).trim();
}

function userStmtTypeFromStr(str) {
  switch (str) {
    case "e" :
        return "e";
    case "p" :
        return "p";
    default:
      throw {
            RE_EXN_ID: MM_parser.MmException,
            _1: {
              msg: "Cannot convert '" + str + "' to userStmtType"
            },
            Error: new Error()
          };
  }
}

function createEmptyUserStmt(id, typ, label) {
  return {
          id: id,
          label: label,
          labelEditMode: false,
          typ: typ,
          typEditMode: false,
          cont: {
            TAG: /* Text */0,
            _0: []
          },
          contEditMode: true,
          jstfText: "",
          jstfEditMode: false,
          stmtErr: undefined,
          expr: undefined,
          jstf: undefined,
          proof: undefined,
          proofStatus: undefined
        };
}

function updateStmt(st, id, update) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.stmts = st.stmts.map(function (stmt) {
        if (stmt.id === id) {
          return Curry._1(update, stmt);
        } else {
          return stmt;
        }
      });
  return newrecord;
}

function isStmtChecked(st, id) {
  return st.checkedStmtIds.includes(id);
}

function toggleStmtChecked(st, id) {
  if (st.checkedStmtIds.includes(id)) {
    var newrecord = Caml_obj.obj_dup(st);
    newrecord.checkedStmtIds = st.checkedStmtIds.filter(function (checkedId) {
          return checkedId !== id;
        });
    return newrecord;
  }
  var newrecord$1 = Caml_obj.obj_dup(st);
  newrecord$1.checkedStmtIds = st.checkedStmtIds.concat([id]);
  return newrecord$1;
}

function checkAllStmts(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.checkedStmtIds = st.stmts.map(function (stmt) {
        return stmt.id;
      });
  return newrecord;
}

function uncheckAllStmts(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.checkedStmtIds = [];
  return newrecord;
}

function deleteCheckedStmts(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.checkedStmtIds = [];
  newrecord.stmts = st.stmts.filter(function (stmt) {
        return !st.checkedStmtIds.includes(stmt.id);
      });
  return newrecord;
}

function deleteStmt(st, id) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.checkedStmtIds = st.checkedStmtIds.filter(function (checkedId) {
        return checkedId !== id;
      });
  newrecord.stmts = st.stmts.filter(function (stmt) {
        return stmt.id !== id;
      });
  return newrecord;
}

function canMoveCheckedStmts(st, up) {
  var len = st.stmts.length;
  if (len !== 0 && st.checkedStmtIds.length !== 0) {
    if (up && !st.checkedStmtIds.includes(Caml_array.get(st.stmts, 0).id)) {
      return true;
    } else if (up) {
      return false;
    } else {
      return !st.checkedStmtIds.includes(Caml_array.get(st.stmts, len - 1 | 0).id);
    }
  } else {
    return false;
  }
}

function moveCheckedStmts(st, up) {
  if (!canMoveCheckedStmts(st, up)) {
    return st;
  }
  var len = st.stmts.length;
  var res = st.stmts.slice();
  if (up) {
    var maxI = len - 2 | 0;
    for(var i = 0; i <= maxI; ++i){
      if (!st.checkedStmtIds.includes(Caml_array.get(res, i).id) && st.checkedStmtIds.includes(Caml_array.get(res, i + 1 | 0).id)) {
        var tmp = Caml_array.get(res, i);
        Caml_array.set(res, i, Caml_array.get(res, i + 1 | 0));
        Caml_array.set(res, i + 1 | 0, tmp);
      }
      
    }
  } else {
    for(var i$1 = len - 1 | 0; i$1 >= 1; --i$1){
      if (st.checkedStmtIds.includes(Caml_array.get(res, i$1 - 1 | 0).id) && !st.checkedStmtIds.includes(Caml_array.get(res, i$1).id)) {
        var tmp$1 = Caml_array.get(res, i$1);
        Caml_array.set(res, i$1, Caml_array.get(res, i$1 - 1 | 0));
        Caml_array.set(res, i$1 - 1 | 0, tmp$1);
      }
      
    }
  }
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.stmts = res;
  return newrecord;
}

function getAllStmtsUpToChecked(st) {
  var checkedAdded = false;
  var res = [];
  var i = 0;
  var stmtsLen = st.stmts.length;
  while(i < stmtsLen && !checkedAdded) {
    var stmt = Caml_array.get(st.stmts, i);
    res.push(stmt);
    checkedAdded = st.checkedStmtIds.includes(stmt.id);
    i = i + 1 | 0;
  };
  return res;
}

function editorGetStmtById(st, id) {
  return Caml_option.undefined_to_opt(st.stmts.find(function (stmt) {
                  return stmt.id === id;
                }));
}

function getStmtsForUnification(st) {
  return getAllStmtsUpToChecked(st).filter(function (stmt) {
                return stmt.typ === "p";
              }).map(function (stmt) {
              var expr = stmt.expr;
              var tmp;
              if (expr !== undefined) {
                tmp = expr;
              } else {
                throw {
                      RE_EXN_ID: MM_parser.MmException,
                      _1: {
                        msg: "Expr must be set for all statements before unification."
                      },
                      Error: new Error()
                    };
              }
              return {
                      label: stmt.label,
                      expr: tmp,
                      justification: stmt.jstf
                    };
            });
}

function createNewLabel(st, prefix) {
  var isLabelDefinedInCtx = function (label) {
    var wrkCtx = st.wrkCtx;
    if (wrkCtx === undefined) {
      return false;
    }
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    if (MM_context.isHyp(wrkCtx$1, label)) {
      return true;
    } else {
      return MM_context.isAsrt(wrkCtx$1, label);
    }
  };
  var usedLabels = st.stmts.map(function (stmt) {
        return stmt.label;
      });
  var i = 1;
  var newLabel = prefix + String(i);
  while(usedLabels.includes(newLabel) || isLabelDefinedInCtx(newLabel)) {
    i = i + 1 | 0;
    newLabel = prefix + String(i);
  };
  return newLabel;
}

function addNewStmt(st) {
  var newId = String(st.nextStmtId);
  var newLabel = createNewLabel(st, "stmt");
  var idToAddBefore = Belt_Option.map(Caml_option.undefined_to_opt(st.stmts.find(function (stmt) {
                return st.checkedStmtIds.includes(stmt.id);
              })), (function (stmt) {
          return stmt.id;
        }));
  var newrecord = Caml_obj.obj_dup(st);
  return [
          (newrecord.stmts = idToAddBefore !== undefined ? Belt_Array.concatMany(st.stmts.map(function (stmt) {
                        if (stmt.id === idToAddBefore) {
                          return [
                                  createEmptyUserStmt(newId, "p", newLabel),
                                  stmt
                                ];
                        } else {
                          return [stmt];
                        }
                      })) : st.stmts.concat([createEmptyUserStmt(newId, "p", newLabel)]), newrecord.nextStmtId = st.nextStmtId + 1 | 0, newrecord),
          newId
        ];
}

function isSingleStmtChecked(st) {
  return st.checkedStmtIds.length === 1;
}

function duplicateCheckedStmt(st) {
  if (!isSingleStmtChecked(st)) {
    return st;
  }
  var newId = String(st.nextStmtId);
  var newLabel = createNewLabel(st, "stmt");
  var idToAddAfter = Caml_array.get(st.checkedStmtIds, 0);
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.checkedStmtIds = [newId];
  newrecord.stmts = Belt_Array.concatMany(st.stmts.map(function (stmt) {
            if (stmt.id === idToAddAfter) {
              return [
                      stmt,
                      {
                        id: newId,
                        label: newLabel,
                        labelEditMode: stmt.labelEditMode,
                        typ: stmt.typ,
                        typEditMode: stmt.typEditMode,
                        cont: stmt.cont,
                        contEditMode: stmt.contEditMode,
                        jstfText: "",
                        jstfEditMode: stmt.jstfEditMode,
                        stmtErr: stmt.stmtErr,
                        expr: stmt.expr,
                        jstf: stmt.jstf,
                        proof: stmt.proof,
                        proofStatus: stmt.proofStatus
                      }
                    ];
            } else {
              return [stmt];
            }
          }));
  newrecord.nextStmtId = st.nextStmtId + 1 | 0;
  return newrecord;
}

function canGoEditModeForStmt(st, stmtId) {
  return !st.stmts.some(function (stmt) {
              if (stmt.id === stmtId) {
                if (stmt.labelEditMode || stmt.typEditMode || stmt.contEditMode) {
                  return true;
                } else {
                  return stmt.jstfEditMode;
                }
              } else {
                return false;
              }
            });
}

function setVarsEditMode(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.varsEditMode = true;
  return newrecord;
}

function setDisjEditMode(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.disjEditMode = true;
  return newrecord;
}

function completeDisjEditMode(st, newDisjText) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.disjEditMode = false;
  newrecord.disjText = newDisjText;
  return newrecord;
}

function setLabelEditMode(st, stmtId) {
  if (canGoEditModeForStmt(st, stmtId)) {
    return updateStmt(st, stmtId, (function (stmt) {
                  return {
                          id: stmt.id,
                          label: stmt.label,
                          labelEditMode: true,
                          typ: stmt.typ,
                          typEditMode: stmt.typEditMode,
                          cont: stmt.cont,
                          contEditMode: stmt.contEditMode,
                          jstfText: stmt.jstfText,
                          jstfEditMode: stmt.jstfEditMode,
                          stmtErr: stmt.stmtErr,
                          expr: stmt.expr,
                          jstf: stmt.jstf,
                          proof: stmt.proof,
                          proofStatus: stmt.proofStatus
                        };
                }));
  } else {
    return st;
  }
}

function completeLabelEditMode(st, stmtId, newLabel) {
  return updateStmt(st, stmtId, (function (stmt) {
                if (newLabel.trim() !== "") {
                  return {
                          id: stmt.id,
                          label: newLabel,
                          labelEditMode: false,
                          typ: stmt.typ,
                          typEditMode: stmt.typEditMode,
                          cont: stmt.cont,
                          contEditMode: stmt.contEditMode,
                          jstfText: stmt.jstfText,
                          jstfEditMode: stmt.jstfEditMode,
                          stmtErr: stmt.stmtErr,
                          expr: stmt.expr,
                          jstf: stmt.jstf,
                          proof: stmt.proof,
                          proofStatus: stmt.proofStatus
                        };
                } else {
                  return stmt;
                }
              }));
}

function setContEditMode(st, stmtId) {
  if (canGoEditModeForStmt(st, stmtId)) {
    return updateStmt(st, stmtId, (function (stmt) {
                  return {
                          id: stmt.id,
                          label: stmt.label,
                          labelEditMode: stmt.labelEditMode,
                          typ: stmt.typ,
                          typEditMode: stmt.typEditMode,
                          cont: stmt.cont,
                          contEditMode: true,
                          jstfText: stmt.jstfText,
                          jstfEditMode: stmt.jstfEditMode,
                          stmtErr: stmt.stmtErr,
                          expr: stmt.expr,
                          jstf: stmt.jstf,
                          proof: stmt.proof,
                          proofStatus: stmt.proofStatus
                        };
                }));
  } else {
    return st;
  }
}

function completeContEditMode(st, stmtId, newContText) {
  return updateStmt(st, stmtId, (function (stmt) {
                if (newContText.trim() === "") {
                  return stmt;
                } else {
                  return {
                          id: stmt.id,
                          label: stmt.label,
                          labelEditMode: stmt.labelEditMode,
                          typ: stmt.typ,
                          typEditMode: stmt.typEditMode,
                          cont: strToCont(newContText, Caml_option.some(st.preCtxColors), Caml_option.some(st.wrkCtxColors), undefined),
                          contEditMode: false,
                          jstfText: stmt.jstfText,
                          jstfEditMode: stmt.jstfEditMode,
                          stmtErr: stmt.stmtErr,
                          expr: stmt.expr,
                          jstf: stmt.jstf,
                          proof: stmt.proof,
                          proofStatus: stmt.proofStatus
                        };
                }
              }));
}

function setTypEditMode(st, stmtId) {
  if (canGoEditModeForStmt(st, stmtId)) {
    return updateStmt(st, stmtId, (function (stmt) {
                  return {
                          id: stmt.id,
                          label: stmt.label,
                          labelEditMode: stmt.labelEditMode,
                          typ: stmt.typ,
                          typEditMode: true,
                          cont: stmt.cont,
                          contEditMode: stmt.contEditMode,
                          jstfText: stmt.jstfText,
                          jstfEditMode: stmt.jstfEditMode,
                          stmtErr: stmt.stmtErr,
                          expr: stmt.expr,
                          jstf: stmt.jstf,
                          proof: stmt.proof,
                          proofStatus: stmt.proofStatus
                        };
                }));
  } else {
    return st;
  }
}

function completeTypEditMode(st, stmtId, newTyp) {
  return updateStmt(st, stmtId, (function (stmt) {
                return {
                        id: stmt.id,
                        label: stmt.label,
                        labelEditMode: stmt.labelEditMode,
                        typ: newTyp,
                        typEditMode: false,
                        cont: stmt.cont,
                        contEditMode: stmt.contEditMode,
                        jstfText: stmt.jstfText,
                        jstfEditMode: stmt.jstfEditMode,
                        stmtErr: stmt.stmtErr,
                        expr: stmt.expr,
                        jstf: stmt.jstf,
                        proof: stmt.proof,
                        proofStatus: stmt.proofStatus
                      };
              }));
}

function setJstfEditMode(st, stmtId) {
  if (canGoEditModeForStmt(st, stmtId)) {
    return updateStmt(st, stmtId, (function (stmt) {
                  return {
                          id: stmt.id,
                          label: stmt.label,
                          labelEditMode: stmt.labelEditMode,
                          typ: stmt.typ,
                          typEditMode: stmt.typEditMode,
                          cont: stmt.cont,
                          contEditMode: stmt.contEditMode,
                          jstfText: stmt.jstfText,
                          jstfEditMode: true,
                          stmtErr: stmt.stmtErr,
                          expr: stmt.expr,
                          jstf: stmt.jstf,
                          proof: stmt.proof,
                          proofStatus: stmt.proofStatus
                        };
                }));
  } else {
    return st;
  }
}

function completeJstfEditMode(st, stmtId, newJstf) {
  return updateStmt(st, stmtId, (function (stmt) {
                return {
                        id: stmt.id,
                        label: stmt.label,
                        labelEditMode: stmt.labelEditMode,
                        typ: stmt.typ,
                        typEditMode: stmt.typEditMode,
                        cont: stmt.cont,
                        contEditMode: stmt.contEditMode,
                        jstfText: newJstf,
                        jstfEditMode: false,
                        stmtErr: stmt.stmtErr,
                        expr: stmt.expr,
                        jstf: stmt.jstf,
                        proof: stmt.proof,
                        proofStatus: stmt.proofStatus
                      };
              }));
}

function incUnifyAllIsRequiredCnt(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.unifyAllIsRequiredCnt = st.unifyAllIsRequiredCnt + 1 | 0;
  return newrecord;
}

function getTypeAndVarFromVarsTextLine(str) {
  var arr = MM_parser.getSpaceSeparatedValuesAsArray(str);
  if (arr.length !== 3) {
    return ;
  } else {
    return [
            Caml_array.get(arr, 1),
            Caml_array.get(arr, 2)
          ];
  }
}

var newLineRegex = /[\n\r]/;

function extractVarColorsFromVarsText(varsText, typeColors) {
  var res = Belt_HashMapString.make(16);
  varsText.split(newLineRegex).forEach(function (lineOpt) {
        if (lineOpt === undefined) {
          return ;
        }
        var match = getTypeAndVarFromVarsTextLine(lineOpt.trim());
        if (match === undefined) {
          return ;
        }
        var color = Belt_HashMapString.get(typeColors, match[0]);
        if (color !== undefined) {
          return Belt_HashMapString.set(res, match[1], color);
        }
        
      });
  return res;
}

function recalcTypeColors(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.typeColors = Belt_HashMapString.fromArray(st.settings.typeSettings.map(function (ts) {
            return [
                    ts.typ,
                    ts.color
                  ];
          }));
  return newrecord;
}

function recalcPreCtxColors(st) {
  var varColorsArr = [];
  MM_context.forEachHypothesisInDeclarationOrder(st.preCtx, (function (hyp) {
          if (hyp.typ === /* F */0) {
            var typeStr = MM_context.ctxIntToSym(st.preCtx, Caml_array.get(hyp.expr, 0));
            if (typeStr !== undefined) {
              var color = Belt_HashMapString.get(st.typeColors, typeStr);
              if (color !== undefined) {
                varColorsArr.push([
                      MM_context.ctxIntToSymExn(st.preCtx, Caml_array.get(hyp.expr, 1)),
                      color
                    ]);
              }
              
            }
            
          }
          
        }));
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.preCtxColors = Belt_HashMapString.fromArray(varColorsArr);
  return newrecord;
}

function recalcWrkCtxColors(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.wrkCtxColors = extractVarColorsFromVarsText(st.varsText, st.typeColors);
  return newrecord;
}

function recalcAllColors(st) {
  var st$1 = recalcTypeColors(st);
  return recalcWrkCtxColors(recalcPreCtxColors(st$1));
}

function updateColorsInAllStmts(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.stmts = st.stmts.map(function (stmt) {
        return {
                id: stmt.id,
                label: stmt.label,
                labelEditMode: stmt.labelEditMode,
                typ: stmt.typ,
                typEditMode: stmt.typEditMode,
                cont: strToCont(contToArrStr(stmt.cont).join(" "), Caml_option.some(st.preCtxColors), Caml_option.some(st.wrkCtxColors), undefined),
                contEditMode: stmt.contEditMode,
                jstfText: stmt.jstfText,
                jstfEditMode: stmt.jstfEditMode,
                stmtErr: stmt.stmtErr,
                expr: stmt.expr,
                jstf: stmt.jstf,
                proof: stmt.proof,
                proofStatus: stmt.proofStatus
              };
      });
  return newrecord;
}

function completeVarsEditMode(st, newVarsText) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.varsEditMode = false;
  newrecord.varsText = newVarsText;
  return updateColorsInAllStmts(recalcWrkCtxColors(newrecord));
}

function setSettings(st, settingsV, settings) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.settings = settings;
  newrecord.settingsV = settingsV;
  return updateColorsInAllStmts(recalcAllColors(newrecord));
}

function setPreCtx(st, preCtxV, preCtx) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.parenCnt = MM_parenCounter.parenCntMake(MM_wrk_ctx.prepareParenInts(preCtx, st.settings.parens), undefined, undefined);
  newrecord.frms = MM_substitution.prepareFrmSubsData(preCtx);
  newrecord.preCtx = preCtx;
  newrecord.preCtxV = preCtxV;
  var st$1 = recalcPreCtxColors(newrecord);
  return updateColorsInAllStmts(recalcWrkCtxColors(st$1));
}

function sortStmtsByType(st) {
  var stmtToInt = function (stmt) {
    var match = stmt.typ;
    if (match === "p") {
      return 2;
    } else {
      return 1;
    }
  };
  var comp = function (a, b) {
    return stmtToInt(a) - stmtToInt(b) | 0;
  };
  var stmtsLen = st.stmts.length;
  if (stmtsLen < 2) {
    return st;
  }
  var newStmts = st.stmts.slice();
  var changed = true;
  var e = stmtsLen - 2 | 0;
  while(e >= 0 && changed) {
    changed = false;
    for(var i = 0; i <= e; ++i){
      if (Curry._2(comp, Caml_array.get(newStmts, i), Caml_array.get(newStmts, i + 1 | 0)) > 0) {
        var tmp = Caml_array.get(newStmts, i);
        Caml_array.set(newStmts, i, Caml_array.get(newStmts, i + 1 | 0));
        Caml_array.set(newStmts, i + 1 | 0, tmp);
        changed = true;
      }
      
    }
    e = e - 1 | 0;
  };
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.stmts = newStmts;
  return newrecord;
}

function removeAllErrorsInUserStmt(stmt) {
  return {
          id: stmt.id,
          label: stmt.label,
          labelEditMode: stmt.labelEditMode,
          typ: stmt.typ,
          typEditMode: stmt.typEditMode,
          cont: stmt.cont,
          contEditMode: stmt.contEditMode,
          jstfText: stmt.jstfText,
          jstfEditMode: stmt.jstfEditMode,
          stmtErr: undefined,
          expr: stmt.expr,
          jstf: stmt.jstf,
          proof: stmt.proof,
          proofStatus: stmt.proofStatus
        };
}

function removeAllErrorsInEditorState(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.stmts = st.stmts.map(removeAllErrorsInUserStmt);
  newrecord.disjErr = undefined;
  newrecord.varsErr = undefined;
  return newrecord;
}

function removeAllProofData(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.stmts = st.stmts.map(function (stmt) {
        return {
                id: stmt.id,
                label: stmt.label,
                labelEditMode: stmt.labelEditMode,
                typ: stmt.typ,
                typEditMode: stmt.typEditMode,
                cont: stmt.cont,
                contEditMode: stmt.contEditMode,
                jstfText: stmt.jstfText,
                jstfEditMode: stmt.jstfEditMode,
                stmtErr: stmt.stmtErr,
                expr: undefined,
                jstf: undefined,
                proof: undefined,
                proofStatus: undefined
              };
      });
  return newrecord;
}

function userStmtHasErrors(stmt) {
  return Belt_Option.isSome(stmt.stmtErr);
}

function editorStateHasErrors(st) {
  if (Belt_Option.isSome(st.varsErr) || Belt_Option.isSome(st.disjErr)) {
    return true;
  } else {
    return st.stmts.some(userStmtHasErrors);
  }
}

function refreshWrkCtx(st) {
  var st$1 = sortStmtsByType(st);
  var st$2 = removeAllErrorsInEditorState(st$1);
  var wrkCtxRes = MM_wrk_ctx.createWrkCtx(st$2.preCtx, st$2.varsText, st$2.disjText, st$2.stmts.filter(function (stmt) {
              return stmt.typ === "e";
            }).map(function (stmt) {
            return {
                    id: stmt.id,
                    label: stmt.label,
                    text: contToArrStr(stmt.cont).join(" ")
                  };
          }));
  if (wrkCtxRes.TAG !== /* Ok */0) {
    var wrkCtxErr = wrkCtxRes._0;
    var msg = wrkCtxErr.varsErr;
    var st$3;
    if (msg !== undefined) {
      var newrecord = Caml_obj.obj_dup(st$2);
      newrecord.varsErr = msg;
      st$3 = newrecord;
    } else {
      st$3 = st$2;
    }
    var msg$1 = wrkCtxErr.disjErr;
    var st$4;
    if (msg$1 !== undefined) {
      var newrecord$1 = Caml_obj.obj_dup(st$3);
      newrecord$1.disjErr = msg$1;
      st$4 = newrecord$1;
    } else {
      st$4 = st$3;
    }
    var match = wrkCtxErr.hypErr;
    if (match === undefined) {
      return st$4;
    }
    var msg$2 = match[1];
    return updateStmt(st$4, match[0], (function (stmt) {
                  return {
                          id: stmt.id,
                          label: stmt.label,
                          labelEditMode: stmt.labelEditMode,
                          typ: stmt.typ,
                          typEditMode: stmt.typEditMode,
                          cont: stmt.cont,
                          contEditMode: stmt.contEditMode,
                          jstfText: stmt.jstfText,
                          jstfEditMode: stmt.jstfEditMode,
                          stmtErr: msg$2,
                          expr: stmt.expr,
                          jstf: stmt.jstf,
                          proof: stmt.proof,
                          proofStatus: stmt.proofStatus
                        };
                }));
  }
  var wrkCtx = wrkCtxRes._0;
  var newrecord$2 = Caml_obj.obj_dup(st$2);
  newrecord$2.wrkCtx = Caml_option.some(wrkCtx);
  return newrecord$2.stmts.reduce((function (st, stmt) {
                if (stmt.typ === "e") {
                  return updateStmt(st, stmt.id, (function (stmt) {
                                return {
                                        id: stmt.id,
                                        label: stmt.label,
                                        labelEditMode: stmt.labelEditMode,
                                        typ: stmt.typ,
                                        typEditMode: stmt.typEditMode,
                                        cont: stmt.cont,
                                        contEditMode: stmt.contEditMode,
                                        jstfText: stmt.jstfText,
                                        jstfEditMode: stmt.jstfEditMode,
                                        stmtErr: stmt.stmtErr,
                                        expr: MM_context.ctxSymsToIntsExn(wrkCtx, contToArrStr(stmt.cont)),
                                        jstf: stmt.jstf,
                                        proof: stmt.proof,
                                        proofStatus: stmt.proofStatus
                                      };
                              }));
                } else {
                  return st;
                }
              }), newrecord$2);
}

function parseJstf(jstfText) {
  var jstfTrim = jstfText.trim();
  if (jstfTrim.length === 0) {
    return {
            TAG: /* Ok */0,
            _0: undefined
          };
  }
  var argsAndAsrt = jstfTrim.split(":");
  if (argsAndAsrt.length !== 2) {
    return {
            TAG: /* Error */1,
            _0: "Cannot parse justification: '" + jstfText + "' [1]."
          };
  } else {
    return {
            TAG: /* Ok */0,
            _0: {
              args: MM_parser.getSpaceSeparatedValuesAsArray(Caml_array.get(argsAndAsrt, 0)),
              asrt: Caml_array.get(argsAndAsrt, 1).trim()
            }
          };
  }
}

function setExprAndJstf(stmt, wrkCtx) {
  if (Belt_Option.isSome(stmt.stmtErr)) {
    return stmt;
  }
  try {
    var msg = parseJstf(stmt.jstfText);
    var tmp;
    if (msg.TAG === /* Ok */0) {
      tmp = msg._0;
    } else {
      throw {
            RE_EXN_ID: MM_parser.MmException,
            _1: {
              msg: msg._0
            },
            Error: new Error()
          };
    }
    return {
            id: stmt.id,
            label: stmt.label,
            labelEditMode: stmt.labelEditMode,
            typ: stmt.typ,
            typEditMode: stmt.typEditMode,
            cont: stmt.cont,
            contEditMode: stmt.contEditMode,
            jstfText: stmt.jstfText,
            jstfEditMode: stmt.jstfEditMode,
            stmtErr: stmt.stmtErr,
            expr: MM_context.ctxSymsToIntsExn(wrkCtx, contToArrStr(stmt.cont)),
            jstf: tmp,
            proof: stmt.proof,
            proofStatus: stmt.proofStatus
          };
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === MM_parser.MmException) {
      return {
              id: stmt.id,
              label: stmt.label,
              labelEditMode: stmt.labelEditMode,
              typ: stmt.typ,
              typEditMode: stmt.typEditMode,
              cont: stmt.cont,
              contEditMode: stmt.contEditMode,
              jstfText: stmt.jstfText,
              jstfEditMode: stmt.jstfEditMode,
              stmtErr: exn._1.msg,
              expr: stmt.expr,
              jstf: stmt.jstf,
              proof: stmt.proof,
              proofStatus: stmt.proofStatus
            };
    }
    throw exn;
  }
}

function isLabelDefined(label, wrkCtx, usedLabels) {
  if (Belt_MutableSetString.has(usedLabels, label) || MM_context.isHyp(wrkCtx, label)) {
    return true;
  } else {
    return MM_context.isAsrt(wrkCtx, label);
  }
}

function validateJstfRefs(stmt, wrkCtx, usedLabels) {
  if (Belt_Option.isSome(stmt.stmtErr)) {
    return stmt;
  }
  var match = stmt.jstf;
  if (match === undefined) {
    return stmt;
  }
  var asrt = match.asrt;
  var ref = match.args.find(function (ref) {
        return !isLabelDefined(ref, wrkCtx, usedLabels);
      });
  if (ref !== undefined) {
    return {
            id: stmt.id,
            label: stmt.label,
            labelEditMode: stmt.labelEditMode,
            typ: stmt.typ,
            typEditMode: stmt.typEditMode,
            cont: stmt.cont,
            contEditMode: stmt.contEditMode,
            jstfText: stmt.jstfText,
            jstfEditMode: stmt.jstfEditMode,
            stmtErr: "The reference '" + ref + "' is not defined.",
            expr: stmt.expr,
            jstf: stmt.jstf,
            proof: stmt.proof,
            proofStatus: stmt.proofStatus
          };
  } else if (MM_context.isAsrt(wrkCtx, asrt)) {
    return stmt;
  } else {
    return {
            id: stmt.id,
            label: stmt.label,
            labelEditMode: stmt.labelEditMode,
            typ: stmt.typ,
            typEditMode: stmt.typEditMode,
            cont: stmt.cont,
            contEditMode: stmt.contEditMode,
            jstfText: stmt.jstfText,
            jstfEditMode: stmt.jstfEditMode,
            stmtErr: "The label '" + asrt + "' doesn't refer to any assertion.",
            expr: stmt.expr,
            jstf: stmt.jstf,
            proof: stmt.proof,
            proofStatus: stmt.proofStatus
          };
  }
}

function validateStmtLabel(stmt, wrkCtx, usedLabels) {
  if (Belt_Option.isSome(stmt.stmtErr) || !isLabelDefined(stmt.label, wrkCtx, usedLabels)) {
    return stmt;
  } else {
    return {
            id: stmt.id,
            label: stmt.label,
            labelEditMode: stmt.labelEditMode,
            typ: stmt.typ,
            typEditMode: stmt.typEditMode,
            cont: stmt.cont,
            contEditMode: stmt.contEditMode,
            jstfText: stmt.jstfText,
            jstfEditMode: stmt.jstfEditMode,
            stmtErr: "Cannot reuse label '" + stmt.label + "'.",
            expr: stmt.expr,
            jstf: stmt.jstf,
            proof: stmt.proof,
            proofStatus: stmt.proofStatus
          };
  }
}

function checkAllStmtsAreUnique(st) {
  var declaredStmts = Belt_MutableMap.make(MM_context.ExprCmp);
  return st.stmts.reduce((function (st, stmt) {
                if (editorStateHasErrors(st)) {
                  return st;
                }
                var expr = stmt.expr;
                var stmt$1;
                if (expr !== undefined) {
                  var prevStmtLabel = Belt_MutableMap.get(declaredStmts, expr);
                  if (prevStmtLabel !== undefined) {
                    stmt$1 = {
                      id: stmt.id,
                      label: stmt.label,
                      labelEditMode: stmt.labelEditMode,
                      typ: stmt.typ,
                      typEditMode: stmt.typEditMode,
                      cont: stmt.cont,
                      contEditMode: stmt.contEditMode,
                      jstfText: stmt.jstfText,
                      jstfEditMode: stmt.jstfEditMode,
                      stmtErr: "This statement is the same as the previous one - '" + prevStmtLabel + "'",
                      expr: stmt.expr,
                      jstf: stmt.jstf,
                      proof: stmt.proof,
                      proofStatus: stmt.proofStatus
                    };
                  } else {
                    Belt_MutableMap.set(declaredStmts, expr, stmt.label);
                    stmt$1 = stmt;
                  }
                } else {
                  throw {
                        RE_EXN_ID: MM_parser.MmException,
                        _1: {
                          msg: "Cannot checkAllStmtsAreUnique without expr."
                        },
                        Error: new Error()
                      };
                }
                return updateStmt(st, stmt$1.id, (function (param) {
                              return stmt$1;
                            }));
              }), st);
}

function prepareProvablesForUnification(st) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var usedLabels = Belt_MutableSetString.make(undefined);
    return st.stmts.reduce((function (st, stmt) {
                  if (editorStateHasErrors(st) || stmt.typ !== "p") {
                    return st;
                  }
                  var stmt$1 = setExprAndJstf(stmt, wrkCtx$1);
                  var stmt$2 = validateJstfRefs(stmt$1, wrkCtx$1, usedLabels);
                  var stmt$3 = validateStmtLabel(stmt$2, wrkCtx$1, usedLabels);
                  Belt_MutableSetString.add(usedLabels, stmt$3.label);
                  return updateStmt(st, stmt$3.id, (function (param) {
                                return stmt$3;
                              }));
                }), st);
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot prepareProvablesForUnification without wrkCtx."
        },
        Error: new Error()
      };
}

function prepareEditorForUnification(st) {
  var st$1 = removeAllErrorsInEditorState(st);
  return [
            removeAllProofData,
            refreshWrkCtx,
            prepareProvablesForUnification,
            checkAllStmtsAreUnique
          ].reduce((function (st, act) {
                if (editorStateHasErrors(st)) {
                  return st;
                } else {
                  return Curry._1(act, st);
                }
              }), st$1);
}

function getTheOnlySelectedStmt(st) {
  if (st.checkedStmtIds.length !== 1) {
    return ;
  }
  var idToFind = Caml_array.get(st.checkedStmtIds, 0);
  var stmt = st.stmts.find(function (stmt) {
        return stmt.id === idToFind;
      });
  if (stmt !== undefined) {
    return stmt;
  }
  
}

function createNewVars(st, varTypes) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var numOfVars = varTypes.length;
    if (numOfVars === 0) {
      return [
              st,
              []
            ];
    }
    var typeToPrefix = Belt_MapString.fromArray(st.settings.typeSettings.map(function (ts) {
              return [
                      ts.typ,
                      ts.prefix
                    ];
            }));
    var newVarNames = MM_context.generateNewVarNames(wrkCtx$1, varTypes, typeToPrefix, undefined, undefined);
    var newHypLabels = MM_context.generateNewLabels(wrkCtx$1, "var", numOfVars, undefined, undefined);
    MM_context.applySingleStmt(wrkCtx$1, {
          TAG: /* Var */3,
          symbols: newVarNames
        });
    var varTypeNames = MM_context.ctxIntsToSymsExn(wrkCtx$1, varTypes);
    newHypLabels.forEach(function (label, i) {
          MM_context.applySingleStmt(wrkCtx$1, {
                TAG: /* Floating */5,
                label: label,
                expr: [
                  Caml_array.get(varTypeNames, i),
                  Caml_array.get(newVarNames, i)
                ]
              });
        });
    var newVarInts = MM_context.ctxSymsToIntsExn(wrkCtx$1, newVarNames);
    var newVarsText = newHypLabels.map(function (label, i) {
            return "" + label + " " + Caml_array.get(varTypeNames, i) + " " + Caml_array.get(newVarNames, i) + "";
          }).join("\n");
    var newrecord = Caml_obj.obj_dup(st);
    newrecord.varsText = st.varsText + (
      st.varsText.trim().length !== 0 ? "\n" : ""
    ) + newVarsText;
    var st$1 = recalcWrkCtxColors(newrecord);
    return [
            st$1,
            newVarInts
          ];
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot create new variables without wrkCtx."
        },
        Error: new Error()
      };
}

function createNewDisj(st, newDisj) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    MM_context.disjForEachArr(newDisj, (function (varInts) {
            MM_context.applySingleStmt(wrkCtx$1, {
                  TAG: /* Disj */4,
                  vars: MM_context.ctxIntsToSymsExn(wrkCtx$1, varInts)
                });
          }));
    var newDisjTextLines = [];
    MM_context.disjForEachArr(newDisj, (function (varInts) {
            newDisjTextLines.push(MM_context.ctxIntsToSymsExn(wrkCtx$1, varInts).join(","));
          }));
    if (newDisjTextLines.length === 0) {
      return st;
    }
    var newDisjText = newDisjTextLines.join("\n");
    var newrecord = Caml_obj.obj_dup(st);
    newrecord.disjText = st.disjText + (
      st.disjText.trim().length !== 0 ? "\n" : ""
    ) + newDisjText;
    return newrecord;
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot create new disjoints without wrkCtx."
        },
        Error: new Error()
      };
}

function addNewStatements(st, newStmts) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var match = createNewVars(st, newStmts.newVarTypes);
    var newCtxVarInts = match[1];
    var newStmtsVarToCtxVar = Belt_MutableMapInt.make(undefined);
    newStmts.newVars.forEach(function (newStmtsVarInt, i) {
          Belt_MutableMapInt.set(newStmtsVarToCtxVar, newStmtsVarInt, Caml_array.get(newCtxVarInts, i));
        });
    var newCtxDisj = MM_context.disjMutableMake(undefined);
    MM_context.disjForEach(newStmts.newDisj, (function (n, m) {
            MM_context.disjAddPair(newCtxDisj, Belt_MutableMapInt.getWithDefault(newStmtsVarToCtxVar, n, n), Belt_MutableMapInt.getWithDefault(newStmtsVarToCtxVar, m, m));
          }));
    var st$1 = createNewDisj(match[0], newCtxDisj);
    var selectionWasEmpty = st$1.checkedStmtIds.length === 0;
    var st$2 = !selectionWasEmpty || st$1.stmts.length === 0 ? st$1 : toggleStmtChecked(st$1, Caml_array.get(st$1.stmts, 0).id);
    var checkedStmt = getTheOnlySelectedStmt(st$2);
    var newStmtsLabelToCtxLabel = Belt_MutableMapString.make(undefined);
    var stMut = {
      contents: st$2
    };
    newStmts.stmts.forEach(function (stmt) {
          if (checkedStmt !== undefined && Belt_Option.getWithDefault(Belt_Option.map(checkedStmt.expr, (function (__x) {
                        return MM_context.exprEq(__x, stmt.expr);
                      })), false)) {
            stMut.contents = updateStmt(stMut.contents, checkedStmt.id, (function (stmtToUpdate) {
                    var match = stmt.jstf;
                    return {
                            id: stmtToUpdate.id,
                            label: stmtToUpdate.label,
                            labelEditMode: stmtToUpdate.labelEditMode,
                            typ: stmtToUpdate.typ,
                            typEditMode: stmtToUpdate.typEditMode,
                            cont: stmtToUpdate.cont,
                            contEditMode: stmtToUpdate.contEditMode,
                            jstfText: match !== undefined ? jstfToStr({
                                    args: match.args.map(function (argLabel) {
                                          return Belt_MutableMapString.getWithDefault(newStmtsLabelToCtxLabel, argLabel, argLabel);
                                        }),
                                    asrt: match.label
                                  }) : stmtToUpdate.jstfText,
                            jstfEditMode: stmtToUpdate.jstfEditMode,
                            stmtErr: stmtToUpdate.stmtErr,
                            expr: stmtToUpdate.expr,
                            jstf: stmtToUpdate.jstf,
                            proof: stmtToUpdate.proof,
                            proofStatus: stmtToUpdate.proofStatus
                          };
                  }));
            return ;
          }
          var ctxLabel = createNewLabel(stMut.contents, "stmt");
          Belt_MutableMapString.set(newStmtsLabelToCtxLabel, stmt.label, ctxLabel);
          var exprText = MM_context.ctxIntsToStrExn(wrkCtx$1, stmt.expr.map(function (i) {
                    return Belt_MutableMapInt.getWithDefault(newStmtsVarToCtxVar, i, i);
                  }));
          var jstfText = Belt_Option.getWithDefault(Belt_Option.map(stmt.jstf, (function (jstf) {
                      return jstfToStr({
                                  args: jstf.args.map(function (label) {
                                        return Belt_MutableMapString.getWithDefault(newStmtsLabelToCtxLabel, label, label);
                                      }),
                                  asrt: jstf.label
                                });
                    })), "");
          var match = addNewStmt(stMut.contents);
          var st = match[0];
          stMut.contents = st;
          stMut.contents = updateStmt(stMut.contents, match[1], (function (stmt) {
                  return {
                          id: stmt.id,
                          label: ctxLabel,
                          labelEditMode: stmt.labelEditMode,
                          typ: "p",
                          typEditMode: stmt.typEditMode,
                          cont: strToCont(exprText, Caml_option.some(st.preCtxColors), Caml_option.some(st.wrkCtxColors), undefined),
                          contEditMode: false,
                          jstfText: jstfText,
                          jstfEditMode: stmt.jstfEditMode,
                          stmtErr: stmt.stmtErr,
                          expr: stmt.expr,
                          jstf: stmt.jstf,
                          proof: stmt.proof,
                          proofStatus: stmt.proofStatus
                        };
                }));
        });
    var st$3 = stMut.contents;
    if (selectionWasEmpty) {
      return uncheckAllStmts(st$3);
    } else {
      return st$3;
    }
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot add assertion search result without wrkCtx."
        },
        Error: new Error()
      };
}

function verifyTypesForSubstitution(settings, ctx, frms, wrkSubs) {
  var typesToProve = Belt_MapInt.toArray(wrkSubs.subs).map(function (param) {
        return [MM_context.getTypeOfVarExn(ctx, param[0])].concat(param[1]);
      });
  var proofTree = MM_provers.proveFloatings(ctx, frms, typesToProve, MM_parenCounter.parenCntMake(MM_wrk_ctx.prepareParenInts(ctx, settings.parens), undefined, undefined), undefined);
  return typesToProve.every(function (typeExpr) {
              var node = MM_proof_tree.ptGetNodeByExpr(proofTree, typeExpr);
              if (node !== undefined) {
                return Belt_Option.isSome(MM_proof_tree.pnGetProof(Caml_option.valFromOption(node)));
              }
              throw {
                    RE_EXN_ID: MM_parser.MmException,
                    _1: {
                      msg: "Unexpected condition met: the proofTree was expected to contain nodes for each typeExpr."
                    },
                    Error: new Error()
                  };
            });
}

function convertSubsToWrkSubs(subs, tmpFrame, ctx) {
  var frameVarToCtxVar = function (frameVar) {
    var ctxSym = Belt_Array.get(tmpFrame.frameVarToSymb, frameVar);
    if (ctxSym !== undefined) {
      return MM_context.ctxSymToIntExn(ctx, ctxSym);
    }
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "Cannot convert frameVar to ctxVar."
          },
          Error: new Error()
        };
  };
  var res = Belt_MutableMapInt.fromArray(Belt_Array.range(1, tmpFrame.numOfVars).map(function (v) {
            return [
                    frameVarToCtxVar(v - 1 | 0),
                    MM_substitution.applySubs([v - 1 | 0], subs, (function (param) {
                            throw {
                                  RE_EXN_ID: MM_parser.MmException,
                                  _1: {
                                    msg: "Work variables are not supported in convertSubsToWrkSubs()."
                                  },
                                  Error: new Error()
                                };
                          }))
                  ];
          }));
  var maxVar = MM_context.getNumOfVars(ctx) - 1 | 0;
  for(var v = 0; v <= maxVar; ++v){
    if (!Belt_MutableMapInt.has(res, v)) {
      Belt_MutableMapInt.set(res, v, [v]);
    }
    
  }
  return {
          newDisj: MM_context.disjMutableMake(undefined),
          subs: Belt_MapInt.fromArray(Belt_MutableMapInt.toArray(res))
        };
}

function verifyDisjoints(wrkSubs, disj) {
  var varToSubVars = Belt_MutableMapInt.make(undefined);
  var getSubVars = function ($$var) {
    var arr = Belt_MutableMapInt.get(varToSubVars, $$var);
    if (arr !== undefined) {
      return arr;
    }
    var expr = Belt_MapInt.get(wrkSubs.subs, $$var);
    Belt_MutableMapInt.set(varToSubVars, $$var, expr !== undefined ? expr.filter(function (s) {
                return s >= 0;
              }) : []);
    return Belt_MutableMapInt.getExn(varToSubVars, $$var);
  };
  var res = {
    contents: true
  };
  MM_context.disjForEach(disj, (function (n, m) {
          if (res.contents) {
            getSubVars(n).forEach(function (nv) {
                  if (res.contents) {
                    getSubVars(m).forEach(function (mv) {
                          if (res.contents) {
                            res.contents = nv !== mv;
                            if (res.contents && !MM_context.disjContains(disj, nv, mv)) {
                              return MM_context.disjAddPair(wrkSubs.newDisj, nv, mv);
                            } else {
                              return ;
                            }
                          }
                          
                        });
                    return ;
                  }
                  
                });
            return ;
          }
          
        }));
  return res.contents;
}

function findPossibleSubs(st, frmExpr, expr) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var axLabel = Caml_array.get(MM_context.generateNewLabels(wrkCtx$1, "temp-ax-", 1, undefined, undefined), 0);
    var match = MM_context.createFrame(wrkCtx$1, axLabel, MM_context.ctxIntsToSymsExn(wrkCtx$1, frmExpr), true, true, undefined);
    var tmpFrame = match[0];
    var frm = MM_substitution.prepareFrmSubsDataForFrame(tmpFrame);
    var disj = MM_context.getAllDisj(wrkCtx$1);
    var foundSubs = [];
    MM_substitution.iterateSubstitutions(tmpFrame.asrt, expr, Caml_array.get(frm.frmConstParts, frm.numOfHypsE), Caml_array.get(frm.constParts, frm.numOfHypsE), Caml_array.get(frm.varGroups, frm.numOfHypsE), frm.subs, MM_parenCounter.parenCntMake(MM_wrk_ctx.prepareParenInts(wrkCtx$1, st.settings.parens), undefined, undefined), (function (subs) {
            var wrkSubs = convertSubsToWrkSubs(subs, tmpFrame, wrkCtx$1);
            if (verifyDisjoints(wrkSubs, disj) && verifyTypesForSubstitution(st.settings, wrkCtx$1, st.frms, wrkSubs)) {
              foundSubs.push(wrkSubs);
            }
            return /* Continue */0;
          }));
    return foundSubs;
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot search for substitutions without wrkCtx."
        },
        Error: new Error()
      };
}

function applyWrkSubs(expr, wrkSubs) {
  var resultSize = {
    contents: 0
  };
  expr.forEach(function (s) {
        if (s < 0) {
          resultSize.contents = resultSize.contents + 1 | 0;
          return ;
        }
        var expr = Belt_MapInt.get(wrkSubs.subs, s);
        if (expr !== undefined) {
          resultSize.contents = resultSize.contents + expr.length | 0;
          return ;
        }
        throw {
              RE_EXN_ID: MM_parser.MmException,
              _1: {
                msg: "Cannot find a substitution for " + String(s) + " in applyWrkSubs."
              },
              Error: new Error()
            };
      });
  var res = new Array(resultSize.contents);
  var e = 0;
  var r = 0;
  while(r < resultSize.contents) {
    var s = Caml_array.get(expr, e);
    if (s < 0) {
      Caml_array.set(res, r, s);
      r = r + 1 | 0;
    } else {
      var subExpr = Belt_MapInt.getExn(wrkSubs.subs, s);
      var len = subExpr.length;
      Expln_utils_common.copySubArray(subExpr, 0, res, r, len);
      r = r + len | 0;
    }
    e = e + 1 | 0;
  };
  return res;
}

function applySubstitutionForEditor(st, wrkSubs) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var st$1 = createNewDisj(st, wrkSubs.newDisj);
    var newrecord = Caml_obj.obj_dup(st$1);
    newrecord.stmts = st$1.stmts.map(function (stmt) {
          var expr = MM_context.ctxSymsToIntsExn(wrkCtx$1, contToArrStr(stmt.cont));
          var newExpr = applyWrkSubs(expr, wrkSubs);
          return {
                  id: stmt.id,
                  label: stmt.label,
                  labelEditMode: stmt.labelEditMode,
                  typ: stmt.typ,
                  typEditMode: stmt.typEditMode,
                  cont: strToCont(MM_context.ctxIntsToStrExn(wrkCtx$1, newExpr), Caml_option.some(st$1.preCtxColors), Caml_option.some(st$1.wrkCtxColors), undefined),
                  contEditMode: stmt.contEditMode,
                  jstfText: stmt.jstfText,
                  jstfEditMode: stmt.jstfEditMode,
                  stmtErr: stmt.stmtErr,
                  expr: stmt.expr,
                  jstf: stmt.jstf,
                  proof: stmt.proof,
                  proofStatus: stmt.proofStatus
                };
        });
    return newrecord;
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot apply substitution without wrkCtx."
        },
        Error: new Error()
      };
}

function removeUnusedVars(st) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var usedSymbols = Belt_SetString.fromArray(Expln_utils_common.arrFlatMap(st.stmts, (function (stmt) {
                return contToArrStr(stmt.cont);
              })));
    var unusedVars = MM_context.getLocalVars(wrkCtx$1).filter(function ($$var) {
          return !Belt_SetString.has(usedSymbols, $$var);
        });
    if (unusedVars.length === 0) {
      return st;
    }
    var unusedVarInts = MM_context.ctxSymsToIntsExn(wrkCtx$1, unusedVars);
    var usedVarsStr = MM_context.getLocalHyps(wrkCtx$1).filter(function (hyp) {
              if (hyp.typ === /* F */0) {
                return !unusedVarInts.includes(Caml_array.get(hyp.expr, 1));
              } else {
                return false;
              }
            }).map(function (hyp) {
            return "" + hyp.label + " " + MM_context.ctxIntToSymExn(wrkCtx$1, Caml_array.get(hyp.expr, 0)) + " " + MM_context.ctxIntToSymExn(wrkCtx$1, Caml_array.get(hyp.expr, 1)) + "";
          }).join("\n");
    var st$1 = completeVarsEditMode(st, usedVarsStr);
    var newDisj = MM_context.disjMutableMake(undefined);
    MM_context.disjForEach(MM_context.getAllDisj(wrkCtx$1), (function (n, m) {
            if (!unusedVarInts.includes(n) && !unusedVarInts.includes(m)) {
              return MM_context.disjAddPair(newDisj, n, m);
            }
            
          }));
    var newDisjStrArr = [];
    MM_context.disjForEachArr(newDisj, (function (varInts) {
            newDisjStrArr.push(MM_context.ctxIntsToSymsExn(wrkCtx$1, varInts).join(","));
          }));
    return prepareEditorForUnification(completeDisjEditMode(st$1, newDisjStrArr.join("\n")));
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot remove unused variables without wrkCtx."
        },
        Error: new Error()
      };
}

function exprSrcToJstf(wrkCtx, proofTree, exprSrc, exprToUserStmt) {
  if (typeof exprSrc === "number") {
    return ;
  }
  if (exprSrc.TAG === /* Hypothesis */0) {
    return ;
  }
  var asrtLabel = exprSrc.label;
  var args = exprSrc.args;
  var frame = MM_context.getFrame(wrkCtx, asrtLabel);
  if (frame === undefined) {
    return ;
  }
  var argLabels = [];
  var argLabelsValid = {
    contents: true
  };
  frame.hyps.forEach(function (hyp, i) {
        if (hyp.typ !== /* E */1) {
          return ;
        }
        var argIdx = Belt_Array.get(args, i);
        if (argIdx === undefined) {
          argLabelsValid.contents = false;
          return ;
        }
        var userStmt = Belt_Map.get(exprToUserStmt, Caml_array.get(proofTree.nodes, argIdx).expr);
        if (userStmt !== undefined) {
          argLabels.push(userStmt.label);
        } else {
          argLabelsValid.contents = false;
        }
      });
  if (argLabelsValid.contents) {
    return {
            args: argLabels,
            asrt: asrtLabel
          };
  }
  
}

function userStmtSetJstfTextAndProof(stmt, wrkCtx, proofTree, proofNode, exprToUserStmt) {
  var proofSrc = proofNode.proof;
  if (proofSrc === undefined) {
    return stmt;
  }
  var jstfFromProof = exprSrcToJstf(wrkCtx, proofTree, proofSrc, exprToUserStmt);
  if (jstfFromProof === undefined) {
    return stmt;
  }
  var existingJstf = stmt.jstf;
  if (existingJstf !== undefined) {
    if (Caml_obj.equal(jstfFromProof, existingJstf)) {
      return {
              id: stmt.id,
              label: stmt.label,
              labelEditMode: stmt.labelEditMode,
              typ: stmt.typ,
              typEditMode: stmt.typEditMode,
              cont: stmt.cont,
              contEditMode: stmt.contEditMode,
              jstfText: stmt.jstfText,
              jstfEditMode: stmt.jstfEditMode,
              stmtErr: stmt.stmtErr,
              expr: stmt.expr,
              jstf: stmt.jstf,
              proof: [
                proofTree,
                proofNode
              ],
              proofStatus: stmt.proofStatus
            };
    } else {
      return stmt;
    }
  } else {
    return {
            id: stmt.id,
            label: stmt.label,
            labelEditMode: stmt.labelEditMode,
            typ: stmt.typ,
            typEditMode: stmt.typEditMode,
            cont: stmt.cont,
            contEditMode: stmt.contEditMode,
            jstfText: jstfToStr(jstfFromProof),
            jstfEditMode: stmt.jstfEditMode,
            stmtErr: stmt.stmtErr,
            expr: stmt.expr,
            jstf: stmt.jstf,
            proof: [
              proofTree,
              proofNode
            ],
            proofStatus: stmt.proofStatus
          };
  }
}

function applyUnifyAllResults(st, proofTreeDto) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var nodes = Belt_HashMap.fromArray(proofTreeDto.nodes.map(function (node) {
              return [
                      node.expr,
                      node
                    ];
            }), MM_context.ExprHash);
    var exprToUserStmt = Belt_Map.fromArray(st.stmts.filter(function (stmt) {
                return Belt_Option.isSome(stmt.expr);
              }).map(function (stmt) {
              return [
                      Belt_Option.getExn(stmt.expr),
                      stmt
                    ];
            }), MM_context.ExprCmp);
    return st.stmts.reduce((function (st, stmt) {
                  var stmt_id = stmt.id;
                  var stmt_label = stmt.label;
                  var stmt_labelEditMode = stmt.labelEditMode;
                  var stmt_typ = stmt.typ;
                  var stmt_typEditMode = stmt.typEditMode;
                  var stmt_cont = stmt.cont;
                  var stmt_contEditMode = stmt.contEditMode;
                  var stmt_jstfText = stmt.jstfText;
                  var stmt_jstfEditMode = stmt.jstfEditMode;
                  var stmt_stmtErr = stmt.stmtErr;
                  var stmt_expr = stmt.expr;
                  var stmt_jstf = stmt.jstf;
                  if (stmt_typ === "p") {
                    return updateStmt(st, stmt_id, (function (stmt) {
                                  var expr = stmt.expr;
                                  if (expr === undefined) {
                                    return stmt;
                                  }
                                  var node = Belt_HashMap.get(nodes, expr);
                                  if (node === undefined) {
                                    return stmt;
                                  }
                                  var stmt$1 = userStmtSetJstfTextAndProof(stmt, wrkCtx$1, proofTreeDto, node, exprToUserStmt);
                                  var match = stmt$1.proof;
                                  if (match !== undefined) {
                                    return {
                                            id: stmt$1.id,
                                            label: stmt$1.label,
                                            labelEditMode: stmt$1.labelEditMode,
                                            typ: stmt$1.typ,
                                            typEditMode: stmt$1.typEditMode,
                                            cont: stmt$1.cont,
                                            contEditMode: stmt$1.contEditMode,
                                            jstfText: stmt$1.jstfText,
                                            jstfEditMode: stmt$1.jstfEditMode,
                                            stmtErr: stmt$1.stmtErr,
                                            expr: stmt$1.expr,
                                            jstf: stmt$1.jstf,
                                            proof: stmt$1.proof,
                                            proofStatus: "ready"
                                          };
                                  }
                                  var jstf = stmt$1.jstf;
                                  if (jstf === undefined) {
                                    return {
                                            id: stmt$1.id,
                                            label: stmt$1.label,
                                            labelEditMode: stmt$1.labelEditMode,
                                            typ: stmt$1.typ,
                                            typEditMode: stmt$1.typEditMode,
                                            cont: stmt$1.cont,
                                            contEditMode: stmt$1.contEditMode,
                                            jstfText: stmt$1.jstfText,
                                            jstfEditMode: stmt$1.jstfEditMode,
                                            stmtErr: stmt$1.stmtErr,
                                            expr: stmt$1.expr,
                                            jstf: stmt$1.jstf,
                                            proof: stmt$1.proof,
                                            proofStatus: "noJstf"
                                          };
                                  }
                                  var parents = node.parents;
                                  if (parents === undefined) {
                                    return {
                                            id: stmt$1.id,
                                            label: stmt$1.label,
                                            labelEditMode: stmt$1.labelEditMode,
                                            typ: stmt$1.typ,
                                            typEditMode: stmt$1.typEditMode,
                                            cont: stmt$1.cont,
                                            contEditMode: stmt$1.contEditMode,
                                            jstfText: stmt$1.jstfText,
                                            jstfEditMode: stmt$1.jstfEditMode,
                                            stmtErr: stmt$1.stmtErr,
                                            expr: stmt$1.expr,
                                            jstf: stmt$1.jstf,
                                            proof: stmt$1.proof,
                                            proofStatus: "jstfIsIncorrect"
                                          };
                                  }
                                  var match$1 = parents.find(function (__x) {
                                        var parentJstf = exprSrcToJstf(wrkCtx$1, proofTreeDto, __x, exprToUserStmt);
                                        if (parentJstf !== undefined) {
                                          return Caml_obj.equal(parentJstf, jstf);
                                        } else {
                                          return false;
                                        }
                                      });
                                  if (match$1 !== undefined) {
                                    return {
                                            id: stmt$1.id,
                                            label: stmt$1.label,
                                            labelEditMode: stmt$1.labelEditMode,
                                            typ: stmt$1.typ,
                                            typEditMode: stmt$1.typEditMode,
                                            cont: stmt$1.cont,
                                            contEditMode: stmt$1.contEditMode,
                                            jstfText: stmt$1.jstfText,
                                            jstfEditMode: stmt$1.jstfEditMode,
                                            stmtErr: stmt$1.stmtErr,
                                            expr: stmt$1.expr,
                                            jstf: stmt$1.jstf,
                                            proof: stmt$1.proof,
                                            proofStatus: "waiting"
                                          };
                                  } else {
                                    return {
                                            id: stmt$1.id,
                                            label: stmt$1.label,
                                            labelEditMode: stmt$1.labelEditMode,
                                            typ: stmt$1.typ,
                                            typEditMode: stmt$1.typEditMode,
                                            cont: stmt$1.cont,
                                            contEditMode: stmt$1.contEditMode,
                                            jstfText: stmt$1.jstfText,
                                            jstfEditMode: stmt$1.jstfEditMode,
                                            stmtErr: stmt$1.stmtErr,
                                            expr: stmt$1.expr,
                                            jstf: stmt$1.jstf,
                                            proof: stmt$1.proof,
                                            proofStatus: "jstfIsIncorrect"
                                          };
                                  }
                                }));
                  } else {
                    return st;
                  }
                }), st);
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot applyUnifyAllResults without wrkCtx."
        },
        Error: new Error()
      };
}

function updateEditorStateWithPostupdateActions(st, update) {
  var st$1 = Curry._1(update, st);
  var st$2 = prepareEditorForUnification(st$1);
  if (Belt_Option.isSome(st$2.wrkCtx)) {
    return removeUnusedVars(st$2);
  } else {
    return st$2;
  }
}

function splitIntoChunks(str, chunkMaxSize) {
  var len = str.length;
  if (len <= chunkMaxSize) {
    return [str];
  }
  var res = [];
  var numberOfChunks = Js_math.ceil_int(len / chunkMaxSize);
  for(var i = 1; i <= numberOfChunks; ++i){
    var begin = Math.imul(i - 1 | 0, chunkMaxSize);
    res.push(str.substr(begin, chunkMaxSize));
  }
  return res;
}

function proofToText(ctx, stmt, proof) {
  if (proof.TAG === /* Uncompressed */0) {
    return "Error: only compressed proofs are supported.";
  }
  var blk = splitIntoChunks(proof.compressedProofBlock, 50).join(" ");
  var asrt = "" + stmt.label + " $p " + contToArrStr(stmt.cont).join(" ") + " $= ( " + proof.labels.join(" ") + " ) " + blk + " $.";
  var localVars = MM_context.getLocalVars(ctx);
  var localDisj = MM_context.getLocalDisj(ctx);
  var localHyps = MM_context.getLocalHyps(ctx);
  var blockIsRequired = localHyps.length > 0 || !MM_context.disjIsEmpty(localDisj);
  var result = [];
  if (blockIsRequired) {
    result.push("${");
  }
  if (localVars.length > 0) {
    result.push("$v " + localVars.join(" ") + " $.");
  }
  MM_context.disjForEachArr(localDisj, (function (vars) {
          result.push("$d " + MM_context.ctxIntsToStrExn(ctx, vars) + " $.");
        }));
  localHyps.forEach(function (hyp) {
        var hypTypStr = hyp.typ === /* F */0 ? " $f " : " $e ";
        result.push(hyp.label + hypTypStr + MM_context.ctxIntsToStrExn(ctx, hyp.expr) + " $.");
      });
  result.push(asrt);
  if (blockIsRequired) {
    result.push("$}");
  }
  return result.join("\r\n");
}

function generateCompressedProof(st, stmtId) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx === undefined) {
    return ;
  }
  var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
  var stmt = st.stmts.find(function (stmt) {
        return stmt.id === stmtId;
      });
  if (stmt === undefined) {
    return ;
  }
  var match = stmt.proof;
  if (match === undefined) {
    return ;
  }
  var proofTable = MM_proof_tree_dto.createProofTable(match[0], match[1]);
  var proof = MM_proof_table.createProof(wrkCtx$1, proofTable, proofTable.length - 1 | 0);
  return proofToText(wrkCtx$1, stmt, proof);
}

function replaceRef(st, replaceWhat, replaceWith) {
  return st.stmts.reduce((function (res, stmt) {
                if (res.TAG !== /* Ok */0) {
                  return res;
                }
                var st = res._0;
                var match = parseJstf(stmt.jstfText);
                if (match.TAG !== /* Ok */0) {
                  return {
                          TAG: /* Error */1,
                          _0: "Cannot parse justification '" + stmt.jstfText + "' for " + stmt.label + ""
                        };
                }
                var jstf = match._0;
                if (jstf === undefined) {
                  return {
                          TAG: /* Ok */0,
                          _0: st
                        };
                }
                if (!jstf.args.includes(replaceWhat)) {
                  return {
                          TAG: /* Ok */0,
                          _0: st
                        };
                }
                var newJstf_args = jstf.args.map(function (ref) {
                      if (ref === replaceWhat) {
                        return replaceWith;
                      } else {
                        return ref;
                      }
                    });
                var newJstf_asrt = jstf.asrt;
                var newJstf = {
                  args: newJstf_args,
                  asrt: newJstf_asrt
                };
                return {
                        TAG: /* Ok */0,
                        _0: updateStmt(st, stmt.id, (function (stmt) {
                                return {
                                        id: stmt.id,
                                        label: stmt.label,
                                        labelEditMode: stmt.labelEditMode,
                                        typ: stmt.typ,
                                        typEditMode: stmt.typEditMode,
                                        cont: stmt.cont,
                                        contEditMode: stmt.contEditMode,
                                        jstfText: jstfToStr(newJstf),
                                        jstfEditMode: stmt.jstfEditMode,
                                        stmtErr: stmt.stmtErr,
                                        expr: stmt.expr,
                                        jstf: stmt.jstf,
                                        proof: stmt.proof,
                                        proofStatus: stmt.proofStatus
                                      };
                              }))
                      };
              }), {
              TAG: /* Ok */0,
              _0: st
            });
}

function mergeStmts(st, id1, id2) {
  var stmt1 = editorGetStmtById(st, id1);
  if (stmt1 === undefined) {
    return {
            TAG: /* Error */1,
            _0: "Cannot find a statement with id = '" + id1 + "'"
          };
  }
  var stmt2 = editorGetStmtById(st, id2);
  if (stmt2 === undefined) {
    return {
            TAG: /* Error */1,
            _0: "Cannot find a statement with id = '" + id2 + "'"
          };
  }
  if (contToArrStr(stmt1.cont).join(" ") !== contToArrStr(stmt2.cont).join(" ")) {
    return {
            TAG: /* Error */1,
            _0: "Statements to merge must have identical expressions."
          };
  }
  var msg = replaceRef(st, stmt2.label, stmt1.label);
  if (msg.TAG !== /* Ok */0) {
    return {
            TAG: /* Error */1,
            _0: msg._0
          };
  }
  var st$1 = deleteStmt(msg._0, id2);
  return {
          TAG: /* Ok */0,
          _0: st$1
        };
}

exports.contIsEmpty = contIsEmpty;
exports.contToArrStr = contToArrStr;
exports.contToStr = contToStr;
exports.strToCont = strToCont;
exports.userStmtTypeFromStr = userStmtTypeFromStr;
exports.createEmptyUserStmt = createEmptyUserStmt;
exports.updateStmt = updateStmt;
exports.isStmtChecked = isStmtChecked;
exports.toggleStmtChecked = toggleStmtChecked;
exports.checkAllStmts = checkAllStmts;
exports.uncheckAllStmts = uncheckAllStmts;
exports.deleteCheckedStmts = deleteCheckedStmts;
exports.deleteStmt = deleteStmt;
exports.canMoveCheckedStmts = canMoveCheckedStmts;
exports.moveCheckedStmts = moveCheckedStmts;
exports.getStmtsForUnification = getStmtsForUnification;
exports.addNewStmt = addNewStmt;
exports.isSingleStmtChecked = isSingleStmtChecked;
exports.duplicateCheckedStmt = duplicateCheckedStmt;
exports.canGoEditModeForStmt = canGoEditModeForStmt;
exports.setVarsEditMode = setVarsEditMode;
exports.completeVarsEditMode = completeVarsEditMode;
exports.setDisjEditMode = setDisjEditMode;
exports.completeDisjEditMode = completeDisjEditMode;
exports.setLabelEditMode = setLabelEditMode;
exports.completeLabelEditMode = completeLabelEditMode;
exports.setContEditMode = setContEditMode;
exports.completeContEditMode = completeContEditMode;
exports.setTypEditMode = setTypEditMode;
exports.completeTypEditMode = completeTypEditMode;
exports.setJstfEditMode = setJstfEditMode;
exports.completeJstfEditMode = completeJstfEditMode;
exports.incUnifyAllIsRequiredCnt = incUnifyAllIsRequiredCnt;
exports.setSettings = setSettings;
exports.setPreCtx = setPreCtx;
exports.editorStateHasErrors = editorStateHasErrors;
exports.refreshWrkCtx = refreshWrkCtx;
exports.prepareProvablesForUnification = prepareProvablesForUnification;
exports.prepareEditorForUnification = prepareEditorForUnification;
exports.addNewStatements = addNewStatements;
exports.findPossibleSubs = findPossibleSubs;
exports.applySubstitutionForEditor = applySubstitutionForEditor;
exports.removeUnusedVars = removeUnusedVars;
exports.applyUnifyAllResults = applyUnifyAllResults;
exports.updateEditorStateWithPostupdateActions = updateEditorStateWithPostupdateActions;
exports.generateCompressedProof = generateCompressedProof;
exports.recalcAllColors = recalcAllColors;
exports.updateColorsInAllStmts = updateColorsInAllStmts;
exports.getTheOnlySelectedStmt = getTheOnlySelectedStmt;
exports.editorGetStmtById = editorGetStmtById;
exports.mergeStmts = mergeStmts;
/* MM_context Not a pure module */
